import React from 'react';
import cn from 'classnames';
import styles from './BadgeIcon.module.scss';
import { BadgeSharedWithMeIcon, ClayUserIcon, CalendarIcon } from '@components/Icons';
import { ReminderBadgeIcon } from '@components/Icons/Reminder';
import Badge from '@components/Contact/Badges/Badge';
import reconnectIcon from '/img/feed/reconnect-icon.svg';
import birthdayIcon from '/img/icons/birthday-no-bg.svg';
import memorialBadge from '/img/icons/memorial-badge.svg';
import newsBadge from '/img/icons/news-badge.svg';
import newsBadgeLight from '/img/icons/news-badge-light.svg';
import Occasion from '@support/Occasion';
import { useTheme } from '@support/hooks/use-theme';

export type BadgeType =
  | 'new-member'
  | 'birthday'
  | 'group'
  | 'calendar'
  | 'shared'
  | 'reminder'
  | 'reconnect'
  | 'memorial'
  | 'none'
  | 'news';

export default function BadgeIcon({ type, date }: { type: BadgeType; date?: Occasion }) {
  const [theme] = useTheme();

  switch (type) {
    case 'new-member':
      return (
        <div className={cn(styles.badge, styles.newBadge)}>
          <ClayUserIcon />
        </div>
      );

    case 'birthday':
      return (
        <div className={cn(styles.badge, styles.birthdayBadge)}>
          <Badge className={styles.birthdayIcon} src={birthdayIcon} />
        </div>
      );

    case 'group':
      return <BadgeSharedWithMeIcon className={cn(styles.badge, styles.groupBadge)} />;

    case 'calendar':
      return (
        <div className={cn(styles.badge, styles.calendarBadge)}>
          <CalendarIcon />
        </div>
      );

    case 'shared':
      return <BadgeSharedWithMeIcon className={styles.badge} />;

    case 'reminder':
      return <ReminderBadgeIcon date={date} className={cn(styles.badge, styles.reminderBadge)} />;

    case 'reconnect':
      return <Badge src={reconnectIcon} icon className={styles.badge} />;

    case 'memorial':
      return <Badge src={memorialBadge} icon className={cn(styles.badge, styles.memorialBadge)} />;

    case 'news':
      return (
        <Badge src={theme === 'light' ? newsBadgeLight : newsBadge} icon className={styles.badge} />
      );

    default:
      return null;
  }
}
